import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#307d9e', // Darker blue for better contrast (was #87CEEB)
      light: '#5BA3C4', // Darker light variant
      dark: '#1A5F7A', // Darker variant
      contrastText: '#FFFFFF',
    },
    secondary: {
      main: '#57A773', // Darker green for better contrast (was #C8D5B9)
      light: '#7FB069',
      dark: '#3E7B3E',
      contrastText: '#FFFFFF',
    },
    background: {
      default: '#F8F9FA',
      paper: '#FFFFFF',
    },
    text: {
      primary: '#2C3E50',
      secondary: '#5D6D7E',
    },
    success: {
      main: '#7FB069', // Darker for better contrast
      light: '#A8D5BA',
      dark: '#5A8B3E',
    },
    warning: {
      main: '#E67E22', // Darker orange for better contrast (was #F4D03F)
      light: '#F39C12',
      dark: '#C0392B',
    },
    error: {
      main: '#C85A5A', // Kept darker variant
      light: '#E8A4A4',
      dark: '#A04A4A',
    },
    info: {
      main: '#3498DB', // Darker blue for better contrast (was #A4C3E8)
      light: '#5DADE2',
      dark: '#2980B9',
    },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontSize: '2.5rem',
      fontWeight: 600,
      lineHeight: 1.2,
      color: '#2C3E50',
    },
    h2: {
      fontSize: '2rem',
      fontWeight: 500,
      lineHeight: 1.3,
      color: '#2C3E50',
    },
    h3: {
      fontSize: '1.75rem',
      fontWeight: 500,
      lineHeight: 1.4,
      color: '#2C3E50',
    },
    h4: {
      fontSize: '1.5rem',
      fontWeight: 500,
      lineHeight: 1.4,
      color: '#2C3E50',
    },
    h5: {
      fontSize: '1.25rem',
      fontWeight: 500,
      lineHeight: 1.5,
      color: '#2C3E50',
    },
    h6: {
      fontSize: '1rem',
      fontWeight: 500,
      lineHeight: 1.5,
      color: '#2C3E50',
    },
    body1: {
      fontSize: '1rem',
      lineHeight: 1.6,
      color: '#2C3E50',
    },
    body2: {
      fontSize: '0.875rem',
      lineHeight: 1.6,
      color: '#5D6D7E',
    },
    button: {
      textTransform: 'none',
      fontWeight: 500,
    },
  },
  shape: {
    borderRadius: 12,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 25,
          padding: '12px 32px',
          fontSize: '1rem',
          fontWeight: 500,
          boxShadow: 'none',
          '&:hover': {
            boxShadow: '0 4px 12px rgba(46, 134, 171, 0.3)', // Updated shadow color
          },
        },
        contained: {
          background: 'linear-gradient(45deg, #2E86AB 30%, #5BA3C4 90%)', // Updated gradient
          '&:hover': {
            background: 'linear-gradient(45deg, #1A5F7A 30%, #2E86AB 90%)',
          },
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 16,
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
          border: '1px solid rgba(46, 134, 171, 0.1)', // Updated border color
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            borderRadius: 12,
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: '#2E86AB', // Updated focus color
            },
          },
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: 'rgba(248, 249, 250, 0.95)',
          backdropFilter: 'blur(10px)',
          boxShadow: '0 2px 20px rgba(0, 0, 0, 0.05)',
          color: '#2C3E50',
        },
      },
    },
    MuiLink: {
      styleOverrides: {
        root: {
          color: '#2E86AB', // Better contrast for links
          textDecoration: 'underline',
          '&:hover': {
            color: '#1A5F7A',
            textDecoration: 'underline',
          },
          '&:visited': {
            color: '#1A5F7A',
          },
        },
      },
    },
  },
});

export default theme; 